import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { PageLoader } from 'routes/PrivateRouter';
import { settingsURLs, settingsTabs } from 'routes/settings/settingsURLs';

import { PermissionGuard } from 'components/PermissionGuard';

import type { ModuleName } from 'types/auth/Module';

// Lazy load Settings component
const Settings = lazy(() =>
  import('pages/settings/Settings').then((m) => ({ default: m.Settings }))
);

// Lazy load Exchange Rates Settings component
const ExchangeRatesSettings = lazy(() =>
  import('pages/settings/exchange-rates/ExchangeRatesSettings').then((m) => ({
    default: m.ExchangeRatesSettings,
  }))
);

export const getSettingsRoutes = (basePathKey: ModuleName) => {
  return [
    ...Object.values(settingsTabs).map((tab) => ({
      path: settingsURLs.getTabURL(tab),
      element: (
        <PermissionGuard moduleKey={basePathKey}>
          <Suspense fallback={<PageLoader />}>
            <Settings tab={tab} />
          </Suspense>
        </PermissionGuard>
      ),
    })),

    // Exchange Rates route
    {
      path: settingsURLs.exchangeRates,
      element: (
        <PermissionGuard moduleKey={basePathKey}>
          <Suspense fallback={<PageLoader />}>
            <ExchangeRatesSettings />
          </Suspense>
        </PermissionGuard>
      ),
    },

    {
      path: settingsURLs.base,
      element: (
        <PermissionGuard moduleKey={basePathKey}>
          <Navigate
            to={settingsURLs.getTabURL(settingsTabs.userManagement)}
            replace
          />
        </PermissionGuard>
      ),
    },

    // Redirect old base path to new authentication path
    {
      path: '/organization-settings',
      element: <Navigate to={settingsURLs.base} replace />,
    },
  ];
};
